import SingleChampion from './single-champion';
export default SingleChampion;